import { Vue, prop } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Loader } from '@/components/loader';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface TabObject {
	title: string;
	id: string;
}

class TabSelectorProps {
	tabs = prop<TabObject[]>({ default: [] })

	active = prop<string>({ default: undefined })

	loading = prop<boolean>({ default: true })

	onChange = prop<Function>({ default: () => () => undefined })
}

export class TabSelector extends Vue.with(TabSelectorProps) {
	selectedId = this.active

	handleClick(id: string) {
		this.selectedId = id;
		this.onChange(this.selectedId);
	}

	@Watch('active')
	updateActive(value: string) {
		if (value === this.selectedId) { return; }
		this.selectedId = value;
	}

	render() {
		return (
			<div class={ styles.tabSelector }>
				<Loader show={ this.loading } />
				{ this.tabs.map(({ id, title }) => (
					<div class={ clsx(styles.tabSelectorTab, id === this.selectedId && styles.tabSelectorTabActive) }
						onClick={ () => this.handleClick(id) }>
						{ title }
					</div>
				))}
			</div>
		);
	}
}
